import { styled } from 'styled-components';

import { cssBreakpoints } from '#/theme/theme';

export const SearchHitCarouselHeader_Box_1 = styled.div`
  flex-direction: column;
  align-items: start;
  display: flex;
  gap: 8px;
  margin-bottom: 48px;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    flex-direction: row;
    justify-content: space-between;
    align-items: end;
  }
`;

export const SearchHitCarouselHeader_Box_2 = styled.div`
  text-align: center;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    text-align: right;
  }
`;
